<script>
  export let label;
  export let link;
  export let flag;
  export let onClick;

  export let disabled;

  import { flags } from "../store.js";

  const addFlag = (flag) => {
    $flags.add(flag);
    $flags = $flags;
  };

  const click = () => {
    if (flag) addFlag(flag);
    if (link) window.open(link, "_blank").focus();
    if (onClick) onClick();
  };
</script>

<div class="locked-button">
  <button type="button" {disabled} on:click={click}>
    {#if !label}
      <slot />
    {:else}
      {label}
    {/if}
  </button>
</div>

<style type="text/scss">
  .locked-button button {
    margin: 0.77em;
    min-width: 130px;
    height: 40px;
    color: #fff;
    padding: 5px 10px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.18s ease-in-out;
    position: relative;
    display: inline-block;
    outline: none;
    border-radius: 20px;
    border: 2px solid var(--color-accent);
    background: var(--color-accent);

    &:not(:disabled):hover {
      background: #fff;
      color: var(--color-accent);
    }

    &:not(:disabled):active {
      top: 2px;
    }

    &:disabled {
      cursor: unset;
      background: gray;
      border: gray;
    }
  }
</style>
